const detectMobilePhone = () => {
    try {
        if (typeof window === 'undefined' || typeof navigator === 'undefined') return false;

        const hasRNBridge = typeof window.ReactNativeWebView !== 'undefined';
        const fromStorage = window.localStorage?.getItem('dailyprofitMobileWebView') === '1';
        const ua = String(navigator.userAgent || '').toLowerCase();
        const webViewUA =
            ua.includes('wv') ||
            ua.includes('webview') ||
            (ua.includes('version/') && ua.includes('chrome/'));

        const looksMobileWebView = Boolean(hasRNBridge || fromStorage || webViewUA);
        if (!looksMobileWebView) return false;

        const cookie = String(window.document?.cookie || '');
        const originMatch = cookie.match(/(?:^|;\s*)erisedMobileKCOrigin=([^;]+)/);
        const loginOrigin = originMatch ? decodeURIComponent(originMatch[1] || '') : '';

        return loginOrigin === 'google';
    } catch (error) {
        return false;
    }
};

export default detectMobilePhone;
